import { ArrowRight, Heart, Zap } from "lucide-react";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 bg-slate-50 overflow-hidden">
        <div className="container-custom relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-6xl font-semibold tracking-tighter text-slate-900 mb-6">
              Passion for <span className="text-blue-600">3D-printing</span> & godt håndværk
            </h1>
            <p className="text-xl text-slate-600 leading-relaxed">
              Mød personerne bag Hj3ddesign og hør historien om, hvordan en hobby blev til en passion for at skabe unikke løsninger.
            </p>
          </div>
        </div>
        <div className="absolute top-0 right-0 w-1/3 h-full bg-slate-100 -skew-x-12 transform translate-x-20 hidden lg:block"></div>
      </section>

      {/* Main Content */}
      <section className="overflow-hidden border-b border-slate-100">
        <div className="grid grid-cols-1 lg:grid-cols-2 items-stretch">
          <div className="relative h-[400px] lg:h-auto">
            <img 
              src="/images/workshop-creators.png" 
              alt="Hans Marius & Joan Edvør i værkstedet" 
              className="w-full h-full object-cover"
            />
          </div>

          <div className="p-8 lg:p-24 flex flex-col justify-center bg-white">
            <div className="max-w-xl">
              <div className="space-y-8">
                <div className="space-y-6">
                  <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 tracking-tight">
                    Hej! Vi hedder Hans Marius & Joan Edvør
                  </h2>
                  <p className="text-lg text-slate-600 leading-relaxed">
                    Vi brænder for at gøre idéer til virkelighed gennem 3D-printing. For os er det ikke bare teknologi; det er et værktøj til at skabe noget, der har værdi for andre.
                  </p>
                  <p className="text-lg text-slate-600 leading-relaxed">
                    Det hele startede som en hobby, hvor vi eksperimenterede med at skabe alt fra små figurer til praktiske brugsgenstande. I dag er det blevet til vores passion at hjælpe andre med at få deres unikke idéer realiseret.
                  </p>
                  <p className="text-lg text-slate-600 leading-relaxed">
                    Hos os får du ikke bare et 3D-print — du får et produkt, der er skabt med omtanke, præcision og kærlighed til detaljen. Vi elsker at eksperimentere med nye designs, materialer og funktioner, så du altid får et resultat, der både imponerer og holder.
                  </p>
                  <p className="text-xl font-semibold text-slate-900 pt-2">
                    Lad os sammen skabe noget unikt!
                  </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-6">
                  <div className="p-6 bg-slate-50 border-l-4 border-blue-600">
                    <Heart className="text-blue-600 mb-3" size={24} />
                    <h3 className="font-bold text-slate-900 mb-1">Skabt med kærlighed</h3>
                    <p className="text-sm text-slate-500">Vi kæler for hver eneste detalje i printet.</p>
                  </div>
                  <div className="p-6 bg-slate-50 border-l-4 border-orange-500">
                    <Zap className="text-orange-500 mb-3" size={24} />
                    <h3 className="font-bold text-slate-900 mb-1">Høj præcision</h3>
                    <p className="text-sm text-slate-500">Vi bruger kun det bedste udstyr på markedet.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



      {/* CTA Section */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="bg-blue-600 p-12 lg:p-20 text-center relative overflow-hidden">
            <div className="relative z-10 space-y-8">
              <h2 className="text-3xl md:text-5xl font-semibold text-white max-w-2xl mx-auto">
                Har du en god idé? Lad os printe den for dig.
              </h2>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/kontakt" className="px-8 py-4 bg-white text-blue-600 font-bold uppercase tracking-widest text-xs hover:bg-slate-100 transition-colors">
                  Kontakt os nu
                </Link>
                <Link to="/ydelser" className="px-8 py-4 bg-transparent border-2 border-white text-white font-bold uppercase tracking-widest text-xs hover:bg-white/10 transition-colors">
                  Se hvad vi tilbyder
                </Link>
              </div>
            </div>
            {/* Pattern Overlay */}
            <div className="absolute inset-0 opacity-10 pointer-events-none">
              <div className="absolute inset-0 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:20px_20px]"></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
